import { formatTextFloat } from '../../../helpers/Text';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import './day-range.scss';

function calculateYearRangeChart(lowestPrice, highestPrice, matchPrice) {
  let $highestPrice = Math.max(highestPrice, lowestPrice);
  let $lowestPrice = Math.min(highestPrice, lowestPrice);

  if ($lowestPrice >= matchPrice) {
    return 0;
  }
  if ($highestPrice <= matchPrice) {
    return 100;
  }
  return (100 * (matchPrice - $lowestPrice)) / ($highestPrice - $lowestPrice);
}

export default class YearRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
    };
  }

  toggleHover = isHover => {
    this.setState({ ...this.state, isHover });
  };

  render() {
    const { isHover } = this.state;
    const { lowestPrice, highestPrice, matchPrice } = this.props;

    return (
      <div
        style={{
          padding: '0px 8px',
          width: '150px',
          height: '18px',
          position: 'relative',
        }}
        onMouseEnter={() => this.toggleHover(true)}
        onMouseLeave={() => this.toggleHover(false)}
      >
        <div className="wl-item-end-yRange">
          <span className="wl-infor-yRange" style={{ float: 'left' }}>
            {formatTextFloat(lowestPrice)}
          </span>
          <small
            className="range-line"
            style={{
              left:
                calculateYearRangeChart(lowestPrice, highestPrice, matchPrice) +
                '%',
            }}
          />
          <span className="wl-infor-yRange" style={{ float: 'right' }}>
            {formatTextFloat(highestPrice)}
          </span>
        </div>

        <div>
          {!isHover && <div className="float-right" />}
          {isHover && (
            <div
              style={{
                top: '-16px',
                left: '14px',
                padding: '0px 10px',
                position: 'absolute',
              }}
              className="tooltip-day-range"
            >
              <div className="d-flex flex-column">
                <p className="tooltip-message-dayrange mb-0">
                  <Translate
                    value="watchListSummary.dayRangeLast"
                    matchPrice={formatTextFloat(matchPrice)}
                  />
                  <span className="ml-2" />
                </p>
                <p className="tooltip-message-dayrange mb-0">
                  <Translate
                    value="watchListSummary.yearRangeTooltip"
                    lowestPrice={formatTextFloat(lowestPrice)}
                    highestPrice={formatTextFloat(highestPrice)}
                  />
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
